import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import { useQuery } from "@apollo/client";
import { GET_ORDERS_CUSTOMER_FOR_ADMIN, GET_PAYMENT_ORDERS } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import { FiDownload } from "react-icons/fi";
import CustomPagination from "../components/Pagination.js";
import Loader from "../components/Loader.js";
import { warehouseOptions } from "../DomesticSellerOrder/AllOrderSeller.js";
import AdminHeader from "./AdminHeader.js";
import Table from "../components/Table/index.jsx";


const typeOptions = [
    { value: "", label: "All" },
    { value: "cancelled", label: "Cancelled" },
    { value: "pending", label: "Pending" },
    { value: "delivered", label: "Delivered" },
    { value: "booked", label: "Booked" },
    { value: "pending pickup", label: "Pending Pickup" },
    { value: "in transit", label: "In Transit" },
    { value: "out for delivery", label: "Out For Delivery" },
    { value: "exception", label: "Exception" },
    { value: "rto", label: "RTO" },
    { value: "rto delivered", label: "RTO Delivered" },
];
const typeOptionsData = [
    { value: "", label: "All" },
    { value: "cod", label: "COD" },
    { value: "prepaid", label: "Prepaid" },

];


const AdminCustomerDetails = () => {
    const location = useLocation();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [selectedDayRange, setSelectedDayRange] = useState(""); // Logical value
    const [selectedDayRangeDelivered, setSelectedDayRangeDelivered] = useState(""); // Logical value
    const [searchUser, setSearchUser] = useState('');
    const [cod_payment_status, setcod_payment_status] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [orderStatusData, setorderStatusData] = useState('');

    const [displayedDayRange, setDisplayedDayRange] = useState({ label: "All", value: "" }); // Displayed value
    const [displayedDayRangeDelivered, setDisplayedDayRangeDelivered] = useState({ label: "All", value: "" }); // Displayed value

    const { data: GetOrderOrder, loading } = useQuery(GET_ORDERS_CUSTOMER_FOR_ADMIN, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            "orderStatus": orderStatus,
            "codPaymentStatus": cod_payment_status,
            dayRange: selectedDayRange,
            deliveryDate: selectedDayRangeDelivered,
            paymentType: paymentType,
            customerId: location?.state?.customerId

        },
        fetchPolicy: "cache-and-network"
    })
    // console.log('✌️GetOrderOrder --->', GetOrderOrder);


    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }
    useEffect(() => {
        if (GetOrderOrder?.getCustomerOrdersAllForAdmin?.data) {
            setOrderData(GetOrderOrder?.getCustomerOrdersAllForAdmin?.data);
        }
    }, [GetOrderOrder]);
    const [activeTab, setActiveTab] = useState("All");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'Pending Payment') {
            setcod_payment_status('pending')
        } else if (tab === 'Success Payment') {
            setcod_payment_status('success')
        } else {
            setcod_payment_status('');
        }
    };
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };



    const capitalizeFirstLetter = (text) => {
        if (!text) return text;
        return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };

    const resetData = () => {
        setPage(0);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setorderStatusData('');
        setPaymentType("");
        // setSelectedPaymentType('');
        setSelectedDayRange("")
        setDisplayedDayRange({ label: "All", value: "" }); // Display "All" in the Select dropdown
        setSelectedDayRangeDelivered("")
        setDisplayedDayRangeDelivered({ label: "All", value: "" }); // Display "All" in the Select dropdown
        setActiveTab('All')
    }
    const columns = [
        { name: "No.", selector: (row, index) => index + 1 + ((page - 1) * limit), sortable: true },

        {
            name: "Shipment Date",
            selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
            sortable: true,
        },
        {
            name: "AWB No.",
            cell: (row) => (
                <Link to="/admintrack" state={{ id: row?.id }} className="text-blue-500 underline">
                    {row?.awb_number}
                </Link>
            ),
            sortable: true,
        },
        {
            name: "Shipment ID",
            selector: (row) => row?.order_id,
            sortable: true,
        },
        {
            name: "Shipment Number",
            cell: (row) => (
                <Link to="/admintrack" state={{ id: row?.id }} className="text-blue-500 underline">
                    {row?.order_number}
                </Link>
            ),
            sortable: true,
        },
        {
            name: "Receiver Details (To)",
            cell: (row) => (
                <div className="relative group max-w-xs truncate cursor-pointer">
                    <span
                        className="truncate max-w-xs block"
                        title={`${row.deliveryAddress?.address1}, ${row.deliveryAddress?.city}, ${row.deliveryAddress?.stateId?.name} - ${row.deliveryAddress?.zipCode}`}
                    >
                        {row?.deliveryAddress?.address1}, {row?.deliveryAddress?.city}.
                    </span>

                    {/* Hover Tooltip */}
                    <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 hidden group-hover:flex flex-col bg-slate-800 text-white p-3 rounded-lg shadow-lg z-50 w-[250px] whitespace-normal">
                        <p className="font-semibold">{row?.deliveryAddress?.name}</p>

                        {row?.package_weight_Length && (
                            <p className="text-sm text-gray-300">Weight: {row?.package_weight_Length}</p>
                        )}

                        {row?.ProductName && (
                            <p className="text-sm text-gray-300">Product: {row?.ProductName}</p>
                        )}

                        <p className="text-sm">
                            {row?.deliveryAddress?.address1}, {row?.deliveryAddress?.city}, {row?.deliveryAddress?.stateId?.name} - {row?.deliveryAddress?.zipCode}
                        </p>
                    </div>
                </div>
            ),
        },



        {
            name: "COD Collectable (₹)",
            selector: (row) => `₹${row?.codCollectableValue || 0}`,
            sortable: true,
        },
        {
            name: "COD Collection (₹)",  // ✅ Added this field
            selector: (row) => `₹${row?.codCollectionValue || 0}`,
            sortable: true,
        },
        {
            name: "Payment Type",
            selector: (row) => row?.payment_type,
            sortable: true,
        },
        {
            name: "RTO Charge (₹)",
            selector: (row) => `₹${row?.rto_order_charge || 0}`,
            sortable: true,
        },
        {
            name: "Shipment Charge (₹)",
            selector: (row) => `₹${row?.order_amount || 0}`,
            sortable: true,
        },
        {
            name: "Total Amount (₹)",
            selector: (row) => `₹${row?.final_order_amount || 0}`,
            sortable: true,
        },
        {
            name: "Net Payable Amount (₹)",
            selector: (row) => `₹${row?.net_receivable_amount || 0}`,
            sortable: true,
        },
        {
            name: "Payment Amount Date",
            selector: (row) => row?.payment_order_Date ? moment(row?.payment_order_Date).format("DD/MM/YYYY HH:mm") : "-",
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => (
                <span
                    className={`px-3 py-1 rounded-lg text-sm font-semibold ${{
                        cancelled: "bg-red-100 text-red-600",
                        pending: "bg-yellow-100 text-yellow-600",
                        booked: "bg-blue-100 text-blue-600",
                        "pending pickup": "bg-green-100 text-green-600",
                        "in transit": "bg-yellow-100 text-yellow-600",
                        "out for delivery": "bg-cyan-100 text-cyan-600",
                        delivered: "bg-green-100 text-green-600",
                        rto: "bg-yellow-100 text-yellow-600",
                        "rto delivered": "bg-indigo-100 text-indigo-600",
                    }[row?.status] || "bg-slate-100 text-gray-600"
                        }`}
                >
                    {row?.status}
                </span>
            ),
            sortable: true,
        },
        {
            name: "COD Payment Status",
            cell: (row) => (
                <span
                    className={`px-3 py-1 rounded-lg text-sm font-semibold ${{
                        pending: "bg-yellow-100 text-yellow-600",
                        success: "bg-green-100 text-green-600",
                    }[row?.cod_payment_status] || "bg-slate-100 text-gray-600"
                        }`}
                >
                    {row?.cod_payment_status}
                </span>
            ),
            sortable: true,
        },
        {
            name: "Delivery Date",
            selector: (row) => row?.delivery_order_Date ? moment(row?.delivery_order_Date).format("DD/MM/YYYY HH:mm") : "-",
            sortable: true,
        },
    ];



    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            Customer : {location?.state?.email}
                        </h1>
                        <button
                            // onClick={downloadExcel}
                            className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <FiDownload className="mr-2 text-lg sm:text-xl" />
                            Export
                        </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Shipment IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Shipment ID"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Status</label>
                            <Select
                                options={typeOptions}
                                // defaultValue={typeOptions[0]}
                                className="w-full"
                                classNamePrefix="react-select"
                                value={orderStatusData}
                                onChange={(selectedOption) => {
                                    setorderStatus(selectedOption?.value); // Update logical value
                                    setorderStatusData(selectedOption); // Update displayed value
                                }}
                                // onChange={(selectedOption) => setorderStatus(selectedOption?.value)}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                        '&:hover': { borderColor: '#2b2b2b' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        zIndex: 1050,
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        zIndex: 1050,
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                        },
                                        zIndex: 1050,
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 1050,
                                        position: 'absolute',
                                    }),
                                }}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={warehouseOptions}
                                // defaultValue={channelOptions[0]}
                                className="w-full"
                                value={displayedDayRange} // Controls the displayed value
                                onChange={(selectedOption) => {
                                    setSelectedDayRange(selectedOption?.value); // Update logical value
                                    setDisplayedDayRange(selectedOption); // Update displayed value
                                }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                        '&:hover': { borderColor: '#2b2b2b' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        zIndex: 1050,
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        zIndex: 1050,
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                        },
                                        zIndex: 1050,
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 1050,
                                        position: 'absolute',
                                    }),
                                }}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Payment Type</label>
                            <Select
                                options={typeOptionsData}
                                defaultValue={typeOptionsData[0]}
                                className="w-full"
                                onChange={(selectedOption) => { setPaymentType(selectedOption?.value); }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                        // paddingTop: '-0.5px', // py-1 corresponds to 0.25rem (4px) on top
                                        // paddingBottom: '-0.5px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                            fontSize: '0.875rem',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',
                                    }),
                                }}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Delivered Date Range</label>
                            <Select
                                options={warehouseOptions}
                                // defaultValue={channelOptions[0]}
                                className="w-full"
                                value={displayedDayRangeDelivered} // Controls the displayed value
                                onChange={(selectedOption) => {
                                    setSelectedDayRangeDelivered(selectedOption?.value); // Update logical value
                                    setDisplayedDayRangeDelivered(selectedOption); // Update displayed value
                                }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#2b2b2b' : '#2b2b2b',
                                        '&:hover': { borderColor: '#2b2b2b' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        zIndex: 1050,
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        zIndex: 1050,
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                        },
                                        zIndex: 1050,
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 1050,
                                        position: 'absolute',
                                    }),
                                }}
                            />
                        </div>

                        <div className="mt-6 flex gap-4">
                            <button className="bg-slate-500 text-white px-4 py-1 rounded-lg text-sm hover:bg-slate-600" onClick={resetData}>
                                Clear
                            </button>
                        </div>

                        {/* <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Warehouse</label>
                        <Select
                            options={warehouseOptions}
                            defaultValue={warehouseOptions[0]}
                            className="w-full"
                            classNamePrefix="react-select"
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#64748B' : '#64748B',
                                    '&:hover': { borderColor: '#64748B' },
                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                    borderRadius: '0.375rem',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#000000',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? 'white' : '#000000',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        color: '#000000',
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    color: '#A3AAB5',
                                }),
                            }}
                        />
                    </div> */}
                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "All",
                            "Pending Payment",
                            "Success Payment",
                            // "In Transit",
                            // "Out For Delivery",
                            // "Delivered",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getCustomerOrdersAllForAdmin?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="mt-2 bg-white p-4 border rounded-lg">
                    <Table
                        columns={columns}
                        data={orderData || []}
                        currentPage={page}
                        totalRecords={orderData?.length || 0}
                        limit={limit}
                        setPage={setPage}
                        setLimit={setLimit}
                        loading={loading}
                        handlePagination={(newPage) => setPage(newPage)}
                    />
                </div>

                {/* Shipment Table Section */}
                {/* <div className="bg-slate-50 rounded-t-lg border mb-9 border-slate-300">
                    <div className=" max-h-[600px] overflow-y-auto overflow-x-auto">
                        <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                            <thead className="bg-slate-100 text-gray-700 sticky top-0 z-10">
                                <tr>
                                    <th className="px-4 py-3">No.</th>
                                    <th className="px-4 py-3">Shipment Date</th>
                                    <th className="px-4 py-3">AWB No.</th>
                                    <th className="px-4 py-3">Shipment ID</th>
                                    <th className="px-4 py-3">Shipment Number</th>
                                    <th className="px-4 py-3">Receiver Details (To)</th>
                                    <th className="px-4 py-3">COD Collectable (₹)</th>
                                    <th className="px-4 py-3">COD Collection (₹)</th>
                                    <th className="px-4 py-3">Payment Type</th>
                                    <th className="px-4 py-3">RTO Charge (₹)</th>
                                    <th className="px-4 py-3">Shipment Charge (₹)</th>
                                    <th className="px-4 py-3">Total Amount (₹)</th>
                                    <th className="px-4 py-3">Net Payble Amount (₹)</th>
                                    <th className="px-4 py-3">payment Amount Date</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">COD payment Status</th>
                                    <th className="px-4 py-3">Delivery Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderData?.length > 0 ? (
                                    orderData.map((shipment, index) => (
                                        <tr key={index} className="border-t bg-white">
                                            <td className="px-4 py-1 text-gray-700">{page * limit + index + 1}</td>
                                            <td className="px-4 py-1 text-gray-700">
                                                {moment(shipment?.createdAt).format('DD/MM/YYYY HH:mm')}
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                <Link to="/admintrack" state={{ id: shipment?.id }}>
                                                    {shipment?.awb_number}
                                                </Link>
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                {shipment?.order_id}
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                <Link to="/admintrack" state={{ id: shipment?.id }}>
                                                    {shipment?.order_number}
                                                </Link>
                                            </td>
                                            <td className="relative  group px-4 py-1 text-gray-700">
                                               
                                                <div className="truncate  max-w-36" >
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.address1)}{" "}
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.city)}.{" "}
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.stateId?.name)} -{" "}
                                                    {shipment?.deliveryAddress?.zipCode}
                                                </div>


                                               
                                                <div className="absolute z-10 hidden group-hover:block bg-slate-700 text-white text-sm rounded-md px-2 py-1 shadow-lg max-w-xs whitespace-normal">
                                                 
                                                    <p className="font-semibold">{shipment?.deliveryAddress?.name}</p>

                                                
                                                    {shipment?.package_weight_Length && (
                                                        <p className="text-sm text-gray-300">Weight: {shipment?.package_weight_Length}</p>
                                                    )}

                                                
                                                    {shipment?.ProductName && (
                                                        <p className="text-sm text-gray-300">Product: {shipment?.ProductName}</p>
                                                    )}

                                                 
                                                    <p className="text-sm">
                                                        {shipment?.deliveryAddress?.address1},{" "}
                                                        {shipment?.deliveryAddress?.city}, {shipment?.deliveryAddress?.stateId?.name} -{" "}
                                                        {shipment?.deliveryAddress?.zipCode}.
                                                    </p>
                                                </div>

                                            </td>

                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.payment_type === 'cod'
                                                    ? `₹${shipment?.ProductPrice}`
                                                    : '   -'}
                                            
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">₹{shipment?.codCollectableValue}</td>
                                            <td className="px-4 py-1 text-gray-700">{shipment.payment_type}</td>
                                           
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {shipment?.rto_order_charge || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">{shipment?.order_amount || 0}</td>

                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.final_order_amount || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.net_receivable_amount || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {shipment?.payment_order_Date ? moment(shipment?.payment_order_Date).format('DD/MM/YYYY HH:mm') : '-'}
                                            </td>

                                            <td className="px-4 py-4">
                                                <span
                                                    className={`px-3 py-1 rounded-lg text-sm font-semibold ${{
                                                        cancelled: "bg-red-100 text-red-600",
                                                        pending: "bg-yellow-100 text-yellow-600",
                                                        booked: "bg-blue-100 text-blue-600",
                                                        "pending pickup": "bg-green-100 text-green-600",
                                                        "in transit": "bg-yellow-100 text-yellow-600", // ✅ Fixed color
                                                        "out for delivery": "bg-cyan-100 text-cyan-600",
                                                        delivered: "bg-green-100 text-green-600",
                                                        rto: "bg-yellow-100 text-yellow-600",
                                                        "rto delivered": "bg-indigo-100 text-indigo-600",
                                                    }[shipment?.status] || "bg-slate-100 text-gray-600"}`}
                                                >
                                                    {shipment?.status}
                                                </span>
                                            </td>

                                            <td className="px-4 py-4">
                                                <span
                                                    className={`px-3 py-1 rounded-lg text-sm font-semibold ${{
                                                        pending: "bg-yellow-100 text-yellow-600",
                                                        success: "bg-green-100 text-green-600",
                                                    }[shipment?.cod_payment_status] || "bg-slate-100 text-gray-600"
                                                        }`}
                                                >
                                                    {shipment?.cod_payment_status}
                                                </span>
                                            </td>
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {shipment?.delivery_order_Date ? moment(shipment?.delivery_order_Date).format('DD/MM/YYYY HH:mm') : '-'}
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    ''
                                )}
                            </tbody>
                        </table>
                    </div>
                    {loading && (
                        <div className="my-10 mx-auto justify-end w-full">
                            <Loader className="mx-auto" />
                        </div>
                    )}
                    {orderData?.length === 0 ? <div className="w-full">
                        <td colSpan="100% " className="flex justify-center">
                            <div className="flex items-center justify-center min-h-[300px] w-full">
                                <NoDataFound />
                            </div>
                        </td>
                    </div>
                        : ''}
                </div> */}
                {GetOrderOrder?.getCustomerOrdersAllForAdmin?.count > 0 && (
                    <CustomPagination
                        totalItems={GetOrderOrder?.getCustomerOrdersAllForAdmin?.count || 0} // Total number of items
                        limit={limit}
                        pageNo={page} // Current page number (zero-based index)
                        handlePageClick={handlePageClick} // Handler to change page
                    />)}


            </div >
        </>
    )
}

export default AdminCustomerDetails
